import { useState } from "react";
import { useQuery } from "@tanstack/react-query";
import { FileText, Eye, Download } from "lucide-react";
import api, { formatApiError } from "@/lib/api";
import { toast } from "sonner";
import { downloadFile, safeName } from "@/lib/download";
import SignedCopyModal from "@/components/agreements/SignedCopyModal";

export default function MyAgreements() {
  const [view, setView] = useState(null);
  const { data: rows = [] } = useQuery({ queryKey: ["my-agreements"], queryFn: () => api.get("/me/agreements").then((r) => r.data) });
  const pdf = async (s) => {
    try { await downloadFile(`/me/signatures/${s.id}/pdf`, `${safeName(s.agreement_title)}.pdf`); }
    catch (e) { toast.error(formatApiError(e.message)); }
  };
  return (
    <div className="eyw-card p-5 sm:p-8 mt-8" data-testid="my-agreements">
      <h2 className="font-serif text-2xl text-[#1A242B] mb-1">My Agreements</h2>
      <p className="text-sm text-[#4A5D6B] mb-5">Everything you've signed, with the version and a readable copy of what you agreed to.</p>
      {rows.length === 0 ? <p className="text-sm text-[#8FA89B]" data-testid="my-agreements-empty">You haven't signed any agreements yet.</p> : (
        <ul className="divide-y divide-[#E5E0D8]">
          {rows.map((s) => (
            <li key={s.id} className="py-3 flex flex-col sm:flex-row sm:items-center gap-2" data-testid={`my-agreement-${s.id}`}>
              <div className="flex items-start gap-3 min-w-0 flex-1">
                <FileText size={16} className="text-[#144F75] mt-0.5 shrink-0" />
                <div className="min-w-0">
                  <div className="text-sm font-semibold text-[#1A242B]">{s.agreement_title}</div>
                  <div className="text-xs text-[#4A5D6B]">
                    Version {s.agreement_version} · signed {String(s.signed_at).slice(0, 10)} · {s.from}
                    {s.booking && ` · for ${s.booking.service_title} on ${s.booking.date}`}
                    {s.current_version > s.agreement_version && <span className="text-[#B5794E]"> · a newer version exists</span>}
                  </div>
                </div>
              </div>
              <div className="flex gap-1.5">
                <button onClick={() => setView(s)} data-testid={`my-agreement-view-${s.id}`} className="eyw-btn-ghost !py-1.5 !px-3 text-xs"><Eye size={13} /> Review</button>
                <button onClick={() => pdf(s)} data-testid={`download-pdf-${s.id}`} className="eyw-btn-ghost !py-1.5 !px-3 text-xs"><Download size={13} /> PDF</button>
              </div>
            </li>
          ))}
        </ul>
      )}
      {view && <SignedCopyModal sigId={view.id} onClose={() => setView(null)} />}
    </div>
  );
}
